// @flow

import * as kv from 'idb-keyval';
import * as React from 'react';
import {useContext, useReducer} from 'react';
import {contextStubFunction, isBrowser} from 'docs/util';
import {StorageReducer} from './StorageReducer';
import {loadItem} from './actions/loadItem';
import {saveItem} from './actions/saveItem';
import type {StorageReducerState} from './StorageReducer';

const DB_NAME = 'docs';
const STORE_NAME = 'docs-keyval-store';

export const Database = isBrowser ? new kv.Store(DB_NAME, STORE_NAME) : null;

export type StorageActions = {|
  loadItem: (key: string) => Promise<any>,
  saveItem: (key: string, value: any) => Promise<void>,
|};

export type StorageContextType = {
  ...StorageReducerState,
  ...StorageActions,
};

const StorageContext = React.createContext<StorageContextType>({
  items: ({}: any),
  loadItem: contextStubFunction('Storage'),
  saveItem: contextStubFunction('Storage'),
});

type StorageProviderProps = {
  children?: React.Node,
};

export const StorageProvider = (props: StorageProviderProps) => {
  const [state, dispatch] = useReducer(StorageReducer, {
    items: {},
  });

  const context = {
    ...state,
    loadItem: loadItem(dispatch, Database),
    saveItem: saveItem(dispatch, Database),
  };

  return (
    <StorageContext.Provider value={context}>
      {props.children}
    </StorageContext.Provider>
  );
};

// NOTE: You will probably find the usePersistentState() hook more useful!
// We need this hook to allow mocking during tests, but using the context
// directly is pretty low-level.
export const useStorage = () => {
  return useContext(StorageContext);
};
